import * as Sentry from '@sentry/react';
import appConfig, { environment } from '@sdk/config/appConfig';

const initSentryReact = (
  sentryEnabled: boolean,
  userId: number = null,
  orgId: number = null
): void => {
  // Initialize Sentry if:
  // - SENTRY_DSN is defined
  // - sentryEnabled is true
  if (appConfig.SENTRY_DSN && sentryEnabled) {
    Sentry.init({
      dsn: appConfig.SENTRY_DSN,
      environment: environment,
    });

    if (userId || orgId) {
      Sentry.setUser({
        id: userId,
        orgId: orgId,
      });
    }
  }
};

export default initSentryReact;
